import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import '../public/static/free.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/public.scss'
import './assets/css/detailInfo.scss'
import gsap from 'gsap'
//引入组件
import './components/myComponents/index.js'
// 引入字体
import '@/assets/fonts/index.css'
//自定义element-ui样式
import './styles/element-ui.scss'
import './styles/diyTable.scss' //自定义table
import *as echarts from 'echarts'
import VueBus from 'vue-bus' // 中央事件总线
import ElementUI from 'element-ui'
import permission from './plugins/permission'
import vueScroll from 'vuescroll' //引入vuescroll
import 'vuescroll/dist/vuescroll.css' //引入vuescroll样式
import horizontalScroll from '../public/el-table-horizontal-scroll'
import '../public/static/ali_icon/iconfont.css'
import router from './router.js'
import store from './store'
import $myPlay from '@/components/myPlay'
import $previewImg from '@/components/previewImg/index.js'
import './filter' //全局过滤器
import {dataPage, getListByDictType} from '@/api/sys/dictData'
import {
  addDateRange,
  closeAndToPage,
  copyText,
  downloadBlobFile,
  handleTree,
  parseTime,
  resetForm,
  selectDataLabel,
  selectDictLabel,
  selectDictLabels,
  selectRanchName,
  validateIDnumber
} from '@/utils/common'
import {getNowDate, stateDict} from '@/utils/index'
import Pagination from '@/components/Pagination'
import SvgIcon  from '@/components/SvgIcon'
import myTitleName from '@/components/myTitleName/index.vue'
import RightToolbar from "@/components/RightToolBar/index.vue";
import sHttp from './request/http.js'
import NetUtil from './RequestMgr/NetUtil'
// import TestJsonUtil from './testData/TestJsonUtil'

import GeoUtils from './utils/geo-util'


import '@/assets/css/custom_icons.scss' // 全局引入
import './views/common/enum/EnumInit.js'
import LoggerUtil from './utils/logger/LoggerUtil'
import RegExpUtil from './utils/verify-data/RegExpUtil'
import LoadingUtil from './utils/LoadingUtil'
import DateUtil from './utils/DateUtil'


//引入自定义指令
import * as directive from "@/directive";

// import Chjg from './views/zzjc/ysgltz/bzdz/bzdz/components/Chjg.js'

import MD5 from '../public/md5/md5'
window.MD5 = MD5
Window.Gsap = gsap
// Vue.use(Chjg)

Vue.use($previewImg)


window.sHttp = sHttp
window.NetUtil = NetUtil
window.DateUtil = DateUtil

window.LoadUtil = LoadingUtil
window.regExp = RegExpUtil
window.logger = LoggerUtil
Vue.prototype.GeoUtils = GeoUtils
window.GeoUtils = GeoUtils
Vue.prototype.$echarts = echarts

// 注册自定义指令
Object.keys(directive).forEach((key) => {
  Vue.directive(key, directive[key])
})


Vue.use(VueBus)

Vue.use(ElementUI)

Vue.use(permission)

Vue.use(vueScroll)//使用
Vue.use(horizontalScroll)

Vue.use($myPlay)

// 图片前缀
Vue.prototype.imageUrlprefix = process.env.VUE_APP_IMAGEURLPREFIX

Vue.config.productionTip = false
Vue.prototype.getDicts = getListByDictType
Vue.prototype.getDictsPage = dataPage
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.selectRanchName = selectRanchName
Vue.prototype.handleTree = handleTree
Vue.prototype.closeAndToPage = closeAndToPage
Vue.prototype.stateDict = stateDict
Vue.prototype.getNowDate = getNowDate
Vue.prototype.downloadBlobFile = downloadBlobFile
Vue.prototype.copyText = copyText
// Vue.prototype.TestJsonUtil = TestJsonUtil
Vue.prototype.selectDataLabel = selectDataLabel
Vue.prototype.validateIDnumber = validateIDnumber
Vue.prototype.msgSuccess = function (msg) {
  this.$message({showClose: true, message: msg, type: 'success'})
}

Vue.prototype.msgError = function (msg) {
  this.$message({showClose: true, message: msg, type: 'error'})
}

Vue.prototype.msgWarning = function (msg) {
  this.$message.warning(msg)
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg)
}


// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('myTitleName', myTitleName)
Vue.component("RightToolbar", RightToolbar);
Vue.component('svg-icon', SvgIcon)

// 引入 SVG 图标
import '@/icons'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
